import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import PageContent from '../../page-content/jsx/page-content.jsx';
import SummaryActions from '../../summary-actions/jsx/summary-actions.jsx';
import SummaryLogTable from '../../summary-log-table/jsx/summary-log-table.jsx';
import LoadingOverlay from '../../loading-overlay/jsx/loading-overlay.jsx';

const Summary = props => {

  const { matrixData, addToPageLog } = useStore(state =>({
    matrixData: state.matrixData,
    addToPageLog: state.addToPageLog
  }), shallow);

  const { reference, page_name } = matrixData['pages'][props.pageId];
  
  const resultsSubheading = matrixData['resultsPageSubheading'];

  let timestamp1 = new Date(Date.now());
  let formattedTimestamp = timestamp1.toString();

  
  useEffect(()=> {
    addToPageLog(props.pageId);
   
    // GTM tracking of summary pages
    window.dataLayer = window.dataLayer || []; window.dataLayer.push({ 
      event: 'nwstResultsPageEvent',
      tracking: {
        event: 'nwstResultsPage', 
        nwstResultsPage: `${page_name}`, 
        nwstResultsPageID: props.pageId 
      }
    }); 
  })
  
  return (
    <div className="decision_wrapper bg_cerulean">
            <h2 className="decision_step">{page_name}</h2>
            <p className="decision_reference">Reference number: {props.pageId}</p>
            <div className="decision_body decision_box">
              <LoadingOverlay />
              <div id="timestamp">Your assessment was made on: {formattedTimestamp}</div>
              <div className="summary-heading-wrapper">
                <h3 className="summary-heading">{resultsSubheading}</h3> 
              </div>
              <div className="summary-contents-wrapper">
                <PageContent pageId={props.pageId} />
                <SummaryLogTable />
              </div>
              <SummaryActions />
            </div>

            
    </div>
  )
}

Summary.propTypes = {
  pageId: PropTypes.string
}

export default Summary